module.exports ={
    api : "https://nepalcorona.info/api/v1/data/nepal"
}